import React from 'react'
import { Box, Text, Group, Avatar, Card, Flex } from '@mantine/core'
import { getImageFile } from '../../../../services/fileImage'
import Carousel from 'react-multi-carousel'
import "react-multi-carousel/lib/styles.css"

const EmptyTutor = () => {
  return (
    <Card withBorder p="md" radius="md" style={{ backgroundColor: '#edf2ff' }}>
      <Group noWrap align='start'>
        <Avatar radius="md" size={80} />
        <Box>
          <Text fz="sm" fw="bold" tt="capitalize">Katalis Team</Text>
          <Text fz="xs" fw='500' tt="capitalize">Tutor Profesional</Text>
        </Box>
      </Group>
    </Card>
  )
}

const TutorSection = ({ tutors }) => {

  const defaultResponsive = {
    desktop: {
      breakpoint: {
        max: 3000,
        min: 1024
      },
      items: 3,
      partialVisibilityGutter: 50
    },
    mobile: {
      breakpoint: {
        max: 464,
        min: 0
      },
      items: 1,
      partialVisibilityGutter: 30
    },
    tablet: {
      breakpoint: {
        max: 1024,
        min: 464
      },
      items: 2,
      partialVisibilityGutter: 30
    }
  }

  const dataTutors = (data) => data.map((val) => {
    const innerHtml = { __html: val.shortProfile }
    return (
      <Card shadow="sm" padding="md" mx={6} radius="md" withBorder style={{ backgroundColor: '#edf2ff' }}>
        <Flex align='start'>
          <Avatar mr={16} radius='md' size={80} src={val.user.image !== "" ? getImageFile(val.user.image) : null} alt={val.user.fullName} />
          <Box>
            <Text fz="sm" mb={-10} fw="bold">{val.user.fullName}</Text>
            <Text fz="xs" fw='500' lineClamp={3} h={75}>{val.shortProfile ? (<Box dangerouslySetInnerHTML={innerHtml} />) : '-'}</Text>
          </Box>
        </Flex>
      </Card>
    )
  })

  return (
    <Box mb={35}>
      <Text fz="md" fw="bold">Pemateri</Text>
      <Box mt="md">
        <Carousel
          arrows={false}
          swipeable
          autoPlay
          autoPlaySpeed={3000}
          responsive={defaultResponsive}
          infinite
        >
          {tutors.length > 0 ? dataTutors(tutors) : <EmptyTutor />}
        </Carousel>
      </Box>
    </Box>
  )
}

export default TutorSection